import { useMemo } from 'react';
import { CalendarChangeParams } from 'primereact/calendar';

export const DEFAULT_DASHBOARD_EMAIL_HOUR = 17;
export const DEFAULT_DASHBOARD_EMAIL_MINUTE = 0;

export interface DashboardEmailSendTime {
  hour: number;
  minute: number;
}

function useDashboardEmailSendTime(
  hour: number | undefined,
  minute: number | undefined,
  onChange: (time: DashboardEmailSendTime) => void
) {
  const value = useMemo(() => {
    const date = new Date();
    date.setHours(hour ?? DEFAULT_DASHBOARD_EMAIL_HOUR, minute ?? DEFAULT_DASHBOARD_EMAIL_MINUTE, 0, 0);
    return date;
  }, [hour, minute]);

  const handleChange = (event: CalendarChangeParams): void => {
    const selected = event.value;
    if (selected instanceof Date) {
      onChange({ hour: selected.getHours(), minute: selected.getMinutes() });
    }
  };

  return { value, handleChange };
}

export default useDashboardEmailSendTime;
